import axios from "axios";
import { uploadImage } from "./ApiEndPoint";

export const CustomUploadProfilePic = async (file, fileType, userId, roomId, venueId) => {
  if (!file) {
    console.log("Please select a file first");
    return null;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileType", fileType);
  formData.append("userId", userId);

  if (roomId) formData.append("roomId", roomId);
  if (venueId) formData.append("venueId", venueId);

  try {
    const res = await axios.post(uploadImage, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Upload failed", error);
    alert("Upload failed, check console");
    return null;
  }
};
